import { render, staticRenderFns } from "./PurchaseInsights.vue?vue&type=template&id=28f8af90&scoped=true"
import script from "./PurchaseInsights.vue?vue&type=script&lang=js"
export * from "./PurchaseInsights.vue?vue&type=script&lang=js"
import style0 from "./PurchaseInsights.vue?vue&type=style&index=0&id=28f8af90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f8af90",
  null
  
)

export default component.exports